import React, { ReactElement } from 'react';

import { Typography } from '@material-ui/core';

import Progress from '../../../../common/components/progress/progress';
import { useStyles } from './login-button-content.styles';

interface Props {
  isLoading: boolean;
  text: string;
}

export default function LoginButtonContent(props: Props): ReactElement {
  const classes = useStyles();

  if (props.isLoading) {
    return <Progress id='login-loading' className={classes.progress} />;
  }

  return (
    <Typography color='inherit' variant='inherit' className={classes.publishBtnText}>
      {props.text}
    </Typography>
  );
}
